export { BinIcon } from "./bin";
